<template>
<v-row dense>
  <v-col cols="10">
    <v-text-field
    outlined
    v-bind="$attrs"
    :value="maskedPhone"
    :rules="phoneRules(required)"
    :error="hasDupePhone"
    :errorMessages="hasDupePhone ? ['A record already exists with this phone number'] : $attrs.errorMessages"
    @keyup="handleValid(); checkDupes()"
    @input="validatePhone($event)"
    @blur="emitPhoneToSave()"
    ref="phone"
    ></v-text-field>
  </v-col>
  <v-col>
    <v-text-field
      outlined
      hide-details
      type="number"
      label="Ext."
      v-model="extension"
      @keyup="handleValid(); checkDupes()"
      @input="validatePhone(phoneToReturn)"
      @blur="emitPhoneToSave()">
    </v-text-field>
  </v-col>
</v-row>
</template>

<script>
export default {
  name: 'EsPhoneField',
  props: {
    value: String,
    required: {
      type: Boolean,
      default: false,
    },
    hasDupePhone: {
      type: Boolean,
      default: false,
    }
  },
  data: () => ({
    errors: [],
    maskedPhone: null,
    extension: null,
    phoneToReturn: null,
  }),
  mounted() {
    if (this.value) {
      this.setExtension(this.value);
      this.validatePhone(this.value);
    }
    this.handleValid();
  },
  methods: {
    handleValid() {
      const errorState = !!(this.$refs.phone.hasError || (this.extension && !this.phoneToReturn));
      this.$emit('isInvalid', errorState);
    },
    checkDupes() {
      this.$emit('checkDupes', { newValue: this.value, isValid: this.phoneToReturn?.length >= 11 });
    },
    setExtension(e) {
      const extensionValue = e?.split('x')[1];
      this.extension = extensionValue;
    },
    validatePhone(e) {
      let maskedValue = e;
      let valueBeforeExtension = e?.split('x')[0].replace(/\D/g, '');
      if (valueBeforeExtension?.length === 10) {
        maskedValue = `(${valueBeforeExtension.substr(0, 3)}) ${valueBeforeExtension.substr(3, 3)}-${valueBeforeExtension.substr(6, 4)}`;
        valueBeforeExtension = `1${valueBeforeExtension}`
      } else if (valueBeforeExtension?.length === 11) {
        maskedValue = `+${valueBeforeExtension.substr(0, 1)} (${valueBeforeExtension.substr(1, 3)}) ${valueBeforeExtension.substr(4, 3)}-${valueBeforeExtension.substr(7, 4)}`;
      } else if (valueBeforeExtension?.length === 12) {
        maskedValue = `+${valueBeforeExtension.substr(0, 2)} (${valueBeforeExtension.substr(2, 3)}) ${valueBeforeExtension.substr(5, 3)}-${valueBeforeExtension.substr(8, 4)}`;
      }
      this.maskedPhone = maskedValue;
      this.phoneToReturn = `${valueBeforeExtension?.length > 0 ? '+' + valueBeforeExtension : ''}`;
      this.emitPhoneToSave();
    },
    emitPhoneToSave() {
      if (this.phoneToReturn || this.extension) {
        this.$emit('input', `${this.phoneToReturn}${this.extension ? 'x' + this.extension : ''}`);
      } else {
        this.$emit('input', null)
      }
    },
    phoneRules(req) {
      return [
        (v) => (!!v || !req) || 'Phone is required',
        (v) => (!v || /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/.test(v)) || 'Phone number format must be one of: (123) 456-1234, +1 (123) 456-1234',
      ];
    },
  },
};
</script>
